module.exports = __webpack_public_path__ + "static/media/desmos-writer.f704f93c.jpg";